import { makeStyles } from 'tss-react/mui';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Button from '@mui/material/Button';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function LoadingButton(props) {
  const { loading, onClick, color, variant, label, disabled, className, style, wrapperStyle } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.root} style={style}>
      <div className={classes.wrapper} style={wrapperStyle}>
        <Button
          variant={variant}
          color={color}
          disabled={loading || disabled}
          className={className || ''}
          onClick={onClick}
          disableElevation
        >
          {label}
        </Button>
        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
      </div>
    </div>
  );
}
